import React from 'react';
import Carousel from 'react-material-ui-carousel'
import {Paper, makeStyles, Grid} from '@material-ui/core'
import Plano from './Plano'

function Item({plano})
{ 
  const classes = useStyles();
  return ( 
    <Paper  className={classes.root}>
      <Grid container
          className={classes.container}
          xs={12}
          spacing={1}
          >
        { plano?.map((atual, index) => (
          <Grid item xs={4} key={atual?.id || index}>
            <div className={classes.item}>
              <Plano data={atual}/>
            </div>
          </Grid>
        ))}
      </Grid>
    </Paper>
  )
}

export default function CarouselplanosF({getPlanos})
{
  const pages = Array.from(Array(Math.ceil(getPlanos.length/3)).keys())
  const planos = pages.map(page => getPlanos.slice(page*3, page*3+3))

  return (
    <Carousel>
      {
        planos?.map( (plano, i) => <Item key={i} plano={plano} /> )
      }
    </Carousel>
  )
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100vw",
    justifyContent: "center",
    alignplanos: "center",
    display: "flex",
  },
  item: {
    height:"100%",
    width:"100%",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
  },
  container: {
    marginTop: "28px",
    width: "100%",
    maxWidth: "1366px",
    alignItems: "center",
    display: "flex",
  },
}));
